import React, {useState, useContext} from 'react'; 
import UserContext  from '../../context/Globales/UserContext';
import { 
    Typography, 
    makeStyles, 
    TableContainer, Table, TableCell, TableRow,TableHead,TableBody, Button,Grid} from '@material-ui/core';
    import {v4 as uuid } from 'uuid';

   


   

    const useStyles = makeStyles((theme) => ({ 
        tituloTable: {
    
            backgroundColor: '#e6e6e6', 
            minWidth: 200,
            color: 'black',
            textAlign: 'center',
            padding: '16px',
            fontWeight: '250',
            fontSize : '16px'
         },   
        TituloIdentificacion: {
    
           backgroundColor: theme.palette.primary.main, 
           minWidth: 200,
           color: 'white',
           textAlign: 'center',
           padding: '15px',
           fontWeight: '250',
           fontSize : '18px',
           height: 'auto',
           alignContent: 'center',               
        },
        FondoTable :{
       
            backgroundColor: theme.palette.greyFondo.main
        },
        containerTable: {
            maxHeight: 440,
            maxWidth: '100%'
          },
    }));

const TblExtractoSociedad = () => {
    const classes = useStyles();
    const  { DatadetalleExtracto } = useContext(UserContext);
   
   
    
    return (
        <div>


<h5>{DatadetalleExtracto == 'ERROR CONSULTA EXTRACTO' ?
                'Error al procesar su solicitud, inténtelo mas tarde (INFORME COMERCIAL)' : ''}</h5>

<h6 className={classes.tituloTable}>Detalle Extracto Sociedad</h6>
{DatadetalleExtracto==null ? <h4>Cargando información...</h4> : 
    <Grid
  container
  direction="row"
  justify="space-between"
  alignItems="flex-start"
>
    <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
    <TableContainer>
          <Table>
        
          <TableHead className={classes.FondoTable}>
          
          <TableRow >
                <TableCell>Extracto</TableCell>
               
          </TableRow>
          </TableHead>
          <TableBody>
                <TableRow >
                    <TableCell align="justify" >
                    { DatadetalleExtracto ? 
                        DatadetalleExtracto?.Descripcion : 'Espere un momento estamos procesando la información...'}
                    </TableCell>
                   
                </TableRow>

          </TableBody>
          

          </Table>
      </TableContainer>
    </Grid>
  

   
    </Grid>
             }
   
        

            
        </div>
    )
   
}

export default TblExtractoSociedad;
